<div class="admin-dashboard">

    <!-- =========================
         ENCABEZADO
    ========================== -->
    <section class="admin-hero">
      <div>
        <span class="eyebrow">Panel administrativo</span>
  
        <h1>Resumen de ABAQ</h1>
  
        <p>
          Consulta la actividad general del servicio social,
          estudiantes e inscripciones desde un solo lugar.
        </p>
      </div>
  
      <div class="hero-status">
        <span class="status-dot"></span>
        Sistema activo
      </div>
    </section>
  
  
    @if (isLoading) {
  
      <!-- =========================
           CARGANDO
      ========================== -->
      <div class="dashboard-loading">
        <div class="loading-spinner"></div>
  
        <div>
          <h3>Cargando información</h3>
          <p>Estamos preparando el resumen administrativo.</p>
        </div>
      </div>
  
    } @else {
  
      <!-- =========================
           MÉTRICAS
      ========================== -->
      <section class="metrics-grid">
  
        <article class="metric-card">
          <div class="metric-icon students-icon">
            ES
          </div>
  
          <div class="metric-content">
            <span class="metric-label">Estudiantes</span>
  
            <strong class="metric-value">
              {{ totalStudents }}
            </strong>
  
            <span class="metric-description">
              Registrados en ABAQ
            </span>
          </div>
        </article>
  
  
        <article class="metric-card">
          <div class="metric-icon activities-icon">
            AC
          </div>
  
          <div class="metric-content">
            <span class="metric-label">Actividades</span>
  
            <strong class="metric-value">
              {{ totalActivities }}
            </strong>
  
            <span class="metric-description">
              Actividades creadas
            </span>
          </div>
        </article>
  
  
        <article class="metric-card">
          <div class="metric-icon registrations-icon">
            IN
          </div>
  
          <div class="metric-content">
            <span class="metric-label">Inscripciones</span>
  
            <strong class="metric-value">
              {{ totalRegistrations }}
            </strong>
  
            <span class="metric-description">
              Participaciones registradas
            </span>
          </div>
        </article>
  
  
        <article class="metric-card attention-card">
          <div class="metric-icon pending-icon">
            !
          </div>
  
          <div class="metric-content">
            <span class="metric-label">Por revisar</span>
  
            <strong class="metric-value">
              {{ pendingValidations }}
            </strong>
  
            <span class="metric-description">
              Asignaciones sin horas validadas
            </span>
          </div>
        </article>
  
      </section>
  
  
      <!-- =========================
           CONTENIDO PRINCIPAL
      ========================== -->
      <section class="dashboard-content">
  
        <!-- PRÓXIMAS ACTIVIDADES -->
        <article class="dashboard-card upcoming-card">
  
          <div class="card-heading">
            <div>
              <span class="section-eyebrow">Agenda</span>
              <h2>Próximas actividades</h2>
              <p>
                Actividades programadas y estudiantes registrados.
              </p>
            </div>
  
            <a
              routerLink="/activity-list"
              class="text-action"
            >
              Ver actividades →
            </a>
          </div>
  
  
          @if (upcomingActivities.length > 0) {
  
            <div class="upcoming-list">
  
              @for (
                item of upcomingActivities;
                track item.activity.id
              ) {
  
                <div class="upcoming-item">
  
                  <div class="activity-date-box">
                    <span class="date-day">
                      {{ item.activity.dueDate | date:'dd' }}
                    </span>
  
                    <span class="date-month">
                      {{ item.activity.dueDate | date:'MMM' }}
                    </span>
                  </div>
  
  
                  <div class="upcoming-info">
                    <div class="upcoming-topline">
  
                      <span class="activity-badge">
                        {{ item.activity.type }}
                      </span>
  
                      <span class="hours-badge">
                        {{ item.activity.valueInHours }} h
                      </span>
  
                    </div>
  
                    <h3>
                      {{ item.activity.title }}
                    </h3>
  
                    <p>
                      {{ item.registeredStudents }}
                      estudiante{{
                        item.registeredStudents === 1 ? '' : 's'
                      }}
                      registrado{{
                        item.registeredStudents === 1 ? '' : 's'
                      }}
                    </p>
                  </div>
  
  
                  <div class="participant-count">
                    <strong>
                      {{ item.registeredStudents }}
                    </strong>
  
                    <span>
                      participantes
                    </span>
                  </div>
  
                </div>
  
              }
  
            </div>
  
          } @else {
  
            <div class="empty-dashboard-state">
              <div class="empty-symbol">+</div>
  
              <h3>No hay próximas actividades</h3>
  
              <p>
                Cuando se creen nuevas actividades aparecerán aquí.
              </p>
            </div>
  
          }
  
        </article>
  
  
        <!-- =========================
             REQUIEREN ATENCIÓN
        ========================== -->
        <article class="dashboard-card attention-panel">
  
          <div class="card-heading">
            <div>
              <span class="section-eyebrow">Seguimiento</span>
              <h2>Requieren atención</h2>
              <p>
                Elementos que conviene revisar.
              </p>
            </div>
          </div>
  
  
          <div class="attention-list">
  
            <div class="attention-item">
              <div class="attention-indicator warning">
                !
              </div>
  
              <div class="attention-info">
                <strong>
                  Horas por revisar
                </strong>
  
                <span>
                  Asignaciones sin validación
                </span>
              </div>
  
              <span class="attention-number">
                {{ pendingValidations }}
              </span>
            </div>
  
  
            <div class="attention-item">
              <div class="attention-indicator neutral">
                E
              </div>
  
              <div class="attention-info">
                <strong>
                  Estudiantes registrados
                </strong>
  
                <span>
                  Comunidad actual
                </span>
              </div>
  
              <span class="attention-number">
                {{ totalStudents }}
              </span>
            </div>
  
  
            <div class="attention-item">
              <div class="attention-indicator success">
                A
              </div>
  
              <div class="attention-info">
                <strong>
                  Actividades disponibles
                </strong>
  
                <span>
                  Oferta actual
                </span>
              </div>
  
              <span class="attention-number">
                {{ totalActivities }}
              </span>
            </div>
  
          </div>
  
  
          <a
            routerLink="/student"
            class="attention-action"
          >
            Revisar estudiantes
            <span>→</span>
          </a>
  
        </article>
  
      </section>
  
  
      <!-- =========================
           RESUMEN DE PARTICIPACIÓN
      ========================== -->
      <section class="dashboard-card participation-card">
  
        <div class="card-heading">
          <div>
            <span class="section-eyebrow">Participación</span>
            <h2>Resumen de actividades</h2>
            <p>
              Consulta rápidamente cuántos estudiantes participan
              en cada actividad.
            </p>
          </div>
        </div>
  
  
        @if (activities.length > 0) {
  
          <div class="participation-list">
  
            @for (activity of activities; track activity.id) {
  
              <div class="participation-row">
  
                <div class="participation-main">
                  <div class="participation-icon">
                    {{ activity.title.charAt(0).toUpperCase() }}
                  </div>
  
                  <div>
                    <strong>
                      {{ activity.title }}
                    </strong>
  
                    <span>
                      {{ activity.type }} ·
                      {{ activity.valueInHours }} horas
                    </span>
                  </div>
                </div>
  
  
                <div class="participation-stat">
                  <strong>
                    {{ countRegistrations(activity.id) }}
                  </strong>
  
                  <span>
                    registrados
                  </span>
                </div>
  
              </div>
  
            }
  
          </div>
  
        } @else {
  
          <div class="empty-dashboard-state">
            <h3>Aún no existen actividades</h3>
  
            <p>
              Crea la primera actividad para comenzar.
            </p>
          </div>
  
        }
  
      </section>
  
    }
  
  </div>